import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-program-title-link-cell',
  templateUrl: './program-title-link-cell.component.html',
  styleUrls: ['./program-title-link-cell.component.css']
})
export class ProgramTitleLinkCellComponent implements AgRendererComponent {
  name: string;
  id: string;
  programImg: string;

  constructor() {}

  refresh(params: ICellRendererParams): boolean {
    this.name = params.data.name;
    this.id = params.data.id;
    this.programImg = params.data.pictureUrl;
    return true;
  }

  agInit(params: ICellRendererParams): void {
    this.name = params.data.name;
    this.id = params.data.id;
    this.programImg = params.data.pictureUrl;
  }
}
